<div *ngIf="item" class="radio-group">
  <div class="radio-item">
    <div class="radio-input">
      <input
        type="radio"
        [id]="makeId(item)"
        [name]="groupName"
        value="item.value"
        (change)="handleChange()"
        (blur)="handleBlur()"
        [checked]="isChecked(item.value)"
        [class.invalid]="item.isInvalid"
        [class.ng-invalid]="radiogGroupInvalid"
      />
      <label [for]="makeId(item)">
        <span class="title"> {{ item.titleKey | i18next }} </span>
        <br />
        <span *ngIf="item.subTitleKey" class="description-text">
          {{ item.subTitleKey | i18next }}
        </span>
      </label>
    </div>
    <div *ngIf="item?.action">
      <button
        [id]="actionId"
        class="action-button"
        (click)="handleActionClick()"
        (blur)="handleBlur()"
      >
        {{
          item.action?.actionLabelKey!
            | i18next
            | parentheses: isParentheses(item)
        }}
        <span *ngIf="isInfo(item)" class="info">
          <i class="fa fa-info" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  </div>
</div>
